import React from 'react';
export function TrashIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
    >
      <path
        d="M2.1001 3.25L2.62781 12.3879C2.64206 12.6346 2.75549 12.8651 2.9423 13.0268V13.0268C3.10858 13.1708 3.32115 13.25 3.54109 13.25H9.45911C9.67904 13.25 9.89162 13.1708 10.0579 13.0268V13.0268C10.2447 12.8651 10.3581 12.6346 10.3724 12.3879L10.9001 3.25"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M4 2.75L4.95625 1.22C5.13899 0.92762 5.45946 0.75 5.80425 0.75H7.19575C7.54054 0.75 7.86101 0.92762 8.04375 1.22L9 2.75"
        stroke="currentColor"
        strokeLinecap="square"
      />
      <path d="M1 3.25H12" stroke="currentColor" strokeLinecap="square" />
    </svg>
  );
}
